import React from "react";
import { AppBarStyle } from "./NavBar.style";
import {
  Card,
  NoSsr,
  useMediaQuery,
  useScrollTrigger,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import SecondNavBar from "./second-navbar/SecondNavbar";
import TopNavBar from "./top-navbar/TopNavBar";

const HeaderComponent = ({ configData: propConfigData }) => {
  const { configData: reduxConfigData } = useSelector((state) => state.configData);
  const configData = propConfigData || reduxConfigData;
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const scrolling = useScrollTrigger();
  
  return (
    <>
      <AppBarStyle
        scrolling={scrolling}
        isSmall={isSmall}
      >
        <Box>
          <NoSsr>
            <Card sx={{ boxShadow: "none", border: "none !important", borderRadius: "0 !important" }}>
              <TopNavBar configData={configData} />
            </Card>
            <SecondNavBar configData={configData} />
          </NoSsr>
        </Box>
      </AppBarStyle>
    </>
  );
};

export default HeaderComponent;
